<template>
    <div class="Chat">
        <div class="Chat__head">
            <button class="Chat__head-contacts" @click.prevent="$emit('openPanel', 'contacts')">
                <i class="fas fa-users"></i>
            </button>
            <h4 v-if="user" class="Chat__head-title truncate">{{ user.profile.name }}</h4>
            <input v-else ref="searchInput" type="text" v-model="search" class="Chat__head-search"
                   placeholder="Rechecher un membre...">
            <button class="Chat__head-alerts" @click.prevent="$emit('openPanel', 'alerts')">
                <i class="fas fa-info"></i>
            </button>
        </div>
        <div v-if="loading" class="Chat__loader">
            <i class="fas fa-spinner fa-spin"></i>
        </div>
        <div v-else-if="user" class="Chat__info">
            <img
                    class="Chat__info-avatar"
                    :src="user.profile.large_avatar"
                    :alt="user.profile.name"/>
            <p class="Chat__info-text">
                Engager une nouvelle discussion avec {{ user.profile.name }}. <br>
                Saisisez votre message ci-dessous.
            </p>
        </div>
        <div v-else-if="search.length > 0">
            <div class="Chat__users" v-if="usersList.length > 0">
                <li v-for="user in usersList" class="Chat__users-item" @click.prevent="handleSelect(user)">
                    <img
                            class="Chat__users-item-avatar"
                            :src="user.profile.small_avatar"
                            :alt="user.profile.name"/>

                    <span>{{ user.profile.name }}</span>
                </li>
            </div>
            <div v-else class="Chat__info">
                <i class="fas fa-user-slash Chat__info-icon"></i>
                <h3 class="Chat__info-title">Aucun résultat</h3>
                <p class="Chat__info-text">
                    Votre recherche ne correspond à aucun de nos membres enregistrés, veuillez effectuer une autre
                    recherche.
                </p>
            </div>
        </div>
        <div v-else class="Chat__info">
            <i class="fas fa-user-plus Chat__info-icon"></i>
            <h3 class="Chat__info-title">Créer une nouvelle discussion</h3>
            <p class="Chat__info-text">
                Veuillez rechercher un utilisateur avec la barre de recherche présente au-dessus afin de d'engager une nouvelle conversation.
            </p>
        </div>
        <chat-form v-if="user" :loading="sending" @submit="handleSubmit"/>
    </div>
</template>

<script>
    import {getters, mutations} from "../../store";
    import {chatFormatTime} from "../../utils";
    import debounce from 'lodash.debounce';
    import Api from "../../services/Api";
    import ChatForm from "./ChatForm";

    export default {
        components: {ChatForm},
        data: function () {
            return {
                search: '',
                usersList: [],
                loading: false,
                sending: false
            }
        },
        watch: {
            search: function () {
                if (this.search.trim().length <= 0) {
                    this.loading = false;
                    return;
                }

                this.loading = true;
                this.usersList = [];
                this.debouncedSearch();
            }
        },
        computed: {
            user: function () {
                return this.usersList.find(user => user.id === getters.newContactId());
            }
        },
        methods: {
            chatFormatTime,
            handleSelect(user) {
                let discussion = getters.discussionWithUser(user.id);
                if (discussion) {
                    mutations.setOpenedDiscussionId(discussion.id);
                    return;
                }

                mutations.setNewContactId(user.id);
            },
            async handleSubmit(message) {
                this.sending = true;

                const {data} = await Api.post('/discussions', {
                    users_ids: [this.user.id],
                    message: message
                });

                mutations.pushDiscussions(data);
                mutations.setOpenedDiscussionId(data.id);
            },
            async handleSearch() {
                const {data} = await Api.get(`/users?s=${this.search}`);
                this.usersList = data;
                this.loading = false;
            }
        },
        created() {
            this.debouncedSearch = debounce(this.handleSearch, 300)
        },
        mounted() {
            let x = window.scrollX, y = window.scrollY;
            this.$refs.searchInput.focus();
            window.scrollTo(x, y);
        }
    }
</script>
